export const CREATE_ENTITY_FAIL_MESSAGE = 'New entity creation is failed';
export const CREATE_DATA_DOURCE_FAIL_MESSAGE = 'New data source creation is failed';